'use client';

import { useEffect, useRef, useState } from 'react';

// 서브픽셀 렌더링 오차를 감안해 95%로 설정
const LAST_CARD_VISIBILITY_THRESHOLD = 0.95;

export function useLastCardVisibility(dataLength: number) {
  const lastCardRef = useRef<HTMLDivElement>(null);
  const [isLastCardVisible, setIsLastCardVisible] = useState(false);

  useEffect(() => {
    const lastCard = lastCardRef.current;
    if (!lastCard) return;

    const list = lastCard.closest('.slick-list');
    if (!list) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsLastCardVisible(entry.isIntersecting);
      },
      { root: list, threshold: LAST_CARD_VISIBILITY_THRESHOLD },
    );
    observer.observe(lastCard);

    return () => observer.disconnect();
  }, [dataLength]);

  return { lastCardRef, isLastCardVisible };
}
